import React from 'react'
import { Container, Nav, Navbar, Button } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import 'line-awesome/dist/line-awesome/css/line-awesome.min.css'
import '../styles/AppHeader.css'

const AppHeader = () => {
  return (
    <Navbar expand="lg" className="app-header" variant="light" sticky="top">
      <Container>
        <Navbar.Brand as={Link} to="/" className="brand-logo">
          <i className="la la-bolt brand-icon" style={{ fontSize: '24px' }} aria-hidden="true"></i>
          <span className="brand-text">MicroGenie</span>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto me-3">
            <Nav.Link as={Link} to="/" className="nav-link">Home</Nav.Link>
            <Nav.Link as={Link} to="/tools" className="nav-link">Tools</Nav.Link>
            <Nav.Link as={Link} to="/about" className="nav-link">About</Nav.Link>
          </Nav>
          <Button as={Link} to="/tools" className="get-started-btn">
            Get Started
          </Button>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  )
}

export default AppHeader